import axios from 'axios'

export const slsClient = {
  async getReqToken () {
    try {
      const slsURL = `${process.env.REACT_APP_SLS_URL}/sso/authorize?client_id=max&no_redirect=true`
      const response = await axios.get(slsURL, { withCredentials: true })

      return response.data
    } catch (error) {
      console.error(error)
      let errorMessage = 'Error getting data from SLSX'

      if (error?.response?.status) {
        errorMessage = `HTTP status (${error.response.status}) - ${errorMessage}`
      }

      throw new Error(errorMessage)
    }
  }
}
